import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  type ListaItens,
  type SeletorItem,
} from '@Lar21/imaginii-web-components/vue'

import {
  encontrarOpcaoDoCatalogo,
  preservarEstadoSemSelecaoVazia,
  prepararEstadoSomenteLeitura,
} from '@next/compartilhados/catalogos/apresentacao/estado-seletor-catalogo'

import {
  CHAVE_I18N_CATALOGO_LOCAL_DE_TRABALHO,
  criarEstadoSeletorCatalogoLocal,
  criarPropriedadesPontotelSeletorLocal,
  extrairValorDoSeletorCatalogoLocal,
  filtrarOpcoesLocalDeTrabalho,
} from './adaptador-catalogo-local-de-trabalho'
import {
  usarCatalogoLocalDeTrabalho,
} from './usar-catalogo-local-de-trabalho'
import type {
  FiltrosCatalogoLocalDeTrabalho,
  OpcaoLocalDeTrabalho,
  SelecaoCatalogoLocalDeTrabalho,
} from '../catalogo-local-de-trabalho.tipos'

type Props = Readonly<{
  modelValue: SelecaoCatalogoLocalDeTrabalho
  selecaoMultipla?: boolean
  tamanho?: 'P' | 'M' | 'G'
  filtros?: FiltrosCatalogoLocalDeTrabalho
  predicado?: (local: OpcaoLocalDeTrabalho) => boolean
  desabilitado?: boolean
  somenteLeitura?: boolean
  permiteSelecionarTodos?: boolean
  permiteLimpar?: boolean
  habilitarDuploClique?: boolean
  label?: string
  placeholder?: string
  mensagemErro?: string | null
  info?: string | null
}>


export default /*@__PURE__*/_defineComponent({
  __name: 'CatalogoLocalDeTrabalho',
  props: {
    modelValue: { type: [Object, Array, null], required: true },
    selecaoMultipla: { type: Boolean, required: false, default: false },
    tamanho: { type: String, required: false, default: 'M' },
    filtros: { type: Object, required: false },
    predicado: { type: Function, required: false },
    desabilitado: { type: Boolean, required: false, default: false },
    somenteLeitura: { type: Boolean, required: false, default: false },
    permiteSelecionarTodos: { type: Boolean, required: false, default: true },
    permiteLimpar: { type: Boolean, required: false, default: true },
    habilitarDuploClique: { type: Boolean, required: false, default: false },
    label: { type: String, required: false },
    placeholder: { type: String, required: false },
    mensagemErro: { type: [String, null], required: false, default: null },
    info: { type: [String, null], required: false, default: null }
  },
  emits: ["update:modelValue", "filtrando-itens", "duplo-clique", "update:selecionouTodos"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const emit = __emit

const { t } = useI18n()
const catalogo = usarCatalogoLocalDeTrabalho(computed(() => !props.somenteLeitura))

const opcoesFiltradas = computed(() => filtrarOpcoesLocalDeTrabalho(
  catalogo.itens.value,
  props.filtros,
  props.predicado,
))

const estadoSeletor = computed(() => prepararEstadoSomenteLeitura(
  criarEstadoSeletorCatalogoLocal(
    opcoesFiltradas.value,
    props.modelValue,
    props.selecaoMultipla,
  ),
  props.somenteLeitura,
  props.modelValue,
))

const erroExibido = computed(() => catalogo.erro.value
  ? t(`${CHAVE_I18N_CATALOGO_LOCAL_DE_TRABALHO}.erroBusca`)
  : props.mensagemErro)

const propriedadesSeletor = computed(() => (
  criarPropriedadesPontotelSeletorLocal({
    traduzir: t,
    ...(props.label !== undefined ? { label: props.label } : {}),
    ...(props.placeholder !== undefined
      ? { placeholder: props.placeholder }
      : {}),
    erro: erroExibido.value,
  })
))

const alterarSelecao = (estado: ListaItens): void => {
  emit(
    'update:modelValue',
    extrairValorDoSeletorCatalogoLocal(
      preservarEstadoSemSelecaoVazia(
        estado,
        estadoSeletor.value,
        props.permiteLimpar,
      ),
      opcoesFiltradas.value,
      props.selecaoMultipla,
    ),
  )
}

const tratarDuploClique = (item: SeletorItem): void => {
  const opcao = encontrarOpcaoDoCatalogo(opcoesFiltradas.value, item)
  if (opcao) emit('duplo-clique', opcao)
}


const __returned__ = { props, emit, t, catalogo, opcoesFiltradas, estadoSeletor, erroExibido, propriedadesSeletor, alterarSelecao, tratarDuploClique }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})